import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ZapperApi } from 'src/app/api/zapper/zapper.api.class';
import { ZapperUpdate } from 'src/app/interfaces/zapper/ZapperUpdate';

@Injectable({
  providedIn: 'root'
})
export class ZapperServiceService {

  constructor(private zapperApi: ZapperApi) { }
  //rename methods
  public initializeZapperTransaction(sessionToken: string): Observable<any> {
    return this.zapperApi.initializeZapperTransaction(sessionToken);
  }

  public updateZapperTransaction(sessionToken: string, zapperUpdate: ZapperUpdate): Observable<any> { 
    return this.zapperApi.updateZapperTransaction(sessionToken, zapperUpdate);
  }

  public pollZapperTransactionStatus(sessionToken: string): Observable<any> {
    return this.zapperApi.pollZapperTransactionStatus(sessionToken);
  }

}
